import { makeLazy } from "lib/make-lazy"

export const PlanSettings = makeLazy(() => import("routes/plan/plan-config/plan-settings"), "PlanSettingsImpl")
